
import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  DOCUMENT
} from '@angular/core';
import { DEFAULT_MAX_FILE_SIZE } from '@shared/file';

export type FileSizeError = { file: File; maxSize: number };

@Directive({
    selector: '[waiFilePicker]',
    standalone: false
})
export class FilePickerDirective implements OnDestroy, OnInit {
  @Input() public waiFilePickerAccept = '*';

  @Input() public waiFilePickerDisabled = false;

  @Output() public waiFilePickerFileChange: EventEmitter<File> = new EventEmitter();

  @Output() public waiFilePickerFileSizeError: EventEmitter<FileSizeError> = new EventEmitter();

  @Input() public waiFilePickerMaxSize: number = DEFAULT_MAX_FILE_SIZE;

  private input: HTMLInputElement = this.document?.createElement('input');

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  public ngOnDestroy(): void {
    this.input.removeEventListener('change', this.onChange);
  }

  public ngOnInit(): void {
    this.input.type = 'file';
    this.input.hidden = true;
    this.input.disabled = this.waiFilePickerDisabled;
    this.input.accept = this.waiFilePickerAccept;

    this.input.addEventListener('change', this.onChange.bind(this));

    this.renderer?.appendChild(this.elementRef?.nativeElement, this.input);
  }

  @HostListener('click')
  public onClick(): void {
    this.input.click();
    // fix for not handling uploading files with the same name for the second time in a row
    this.input.value = '';
  }

  private onChange(event: Event): void {
    const file: File = (event.target as HTMLInputElement).files?.[0];

    if (!file) {
      return;
    }

    if (file.size > this.waiFilePickerMaxSize) {
      this.waiFilePickerFileSizeError.emit({ file, maxSize: this.waiFilePickerMaxSize });
    } else {
      this.waiFilePickerFileChange.emit(file);
    }
  }
}
